import { FORMATTED_DATE } from './EmailConstants'

export const emailDataFormatter = (formData: any) => {
  const FirstName = formData?.firstName + '\n' ?? ''
  const LastName = formData?.lastName + '\n' ?? ''
  const Work = formData?.workEmail + '\n' ?? ''
  const Mobile = formData?.mobile + '\n' ?? ''
  const Website = formData?.website + '\n' ?? ''
  const Timeline = formData?.tellMore + '\n' ?? ''
  const Volume = formData?.payVolumn + '\n' ?? ''
  const date = FORMATTED_DATE + '\n' ?? ''

  return ` 
    First Name: ${encodeURIComponent(FirstName)}
    Last Name: ${encodeURIComponent(LastName)}
    Work email address: ${encodeURIComponent(Work)}
    Mobile number: ${encodeURIComponent(Mobile)}
    Company website: ${encodeURIComponent(Website)}
    Daily Transaction Value: ${encodeURIComponent(Volume)}
    Date of Inquiry: ${encodeURIComponent(date)}
    Note: ${encodeURIComponent(Timeline)}`
}
